import { ReactNode } from "react";

import { IntlShape } from "react-intl";

import FeatureGates from "@atlaskit/feature-gate-js-client";

import { Link } from "@/libraries/design/components";

type GetBannerConfigOptions = {
    readonly intl: IntlShape;
    readonly linkUrl: string;
};

export const getBannerConfig = ({ intl, linkUrl }: GetBannerConfigOptions) => {
    const isBannerEnabled = FeatureGates.checkGate(
        "gwp-2022-jsm-paid-lp-banner"
    );

    return isBannerEnabled
        ? {
              identifier: "jira-service-management.banner-alert.itsm-leader",
              text: intl.formatMessage(
                  {
                      id: "jira-service-management.banner-alert.itsm-leader.text",
                      defaultMessage:
                          "There’s a new leader in ITSM software. <a>See why companies are switching</a> to Jira Service Management."
                  },
                  {
                      a: (chunks: ReactNode) => (
                          <Link
                              text={(chunks || "").toString()}
                              href={linkUrl}
                              type="inline"
                          />
                      )
                  }
              )
          }
        : undefined;
};
